import { Icon, Box, FormControl } from '@mui/material';
import useAnalytics, { eventName } from '@/hooks/use-analytics';
import { StyledChip } from './StyledChip';

export const BaseChipElement = ({
  onChange,
  options,
  value,
}: {
  onChange: (value: string | number | boolean | null) => void;
  options: { value: string | number | boolean; label: string; icon?: string }[];
  value: string | number | boolean | null;
}) => {
  const { trackClick } = useAnalytics();

  return (
    <FormControl sx={{ display: 'contents' }}>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {options.map((option) => {
          const selected = value === option.value;
          const icon = selected ? <Icon color='primary'>{option.icon ?? 'check'}</Icon> : undefined;
          return (
            <StyledChip
              key={option.value.toString()}
              icon={icon}
              label={option.label}
              onClick={() => {
                trackClick(eventName(option.label));
                onChange(option.value);
              }}
              size={'small'}
              variant={'outlined'}
              selected={selected}
            />
          );
        })}
      </Box>
    </FormControl>
  );
};
